import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Navigate, Route, Routes, useParams} from 'react-router-dom';


import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';
import {getProfileChangeHistory} from 'src/openapi/admin/apis/ProfileChangeHistoryApi';

import Loading from '@pb/kit-component-loading';

import {ProfileHistoryRecord} from './profile-history-record';

import type {ProfileChangeRecord} from 'src/openapi/admin/models/ProfileChangeRecord';
import type {ApiDispatchForToolkit} from 'src/openapi/admin/types';
import type {ServerResponse} from 'src/typedef';

export const ProfileHistorySwitch = () => {
    const queryParams = useParams<{roleId: string}>();
    const apiDispatch = useDispatch<ApiDispatchForToolkit>();
    const profileId = useMemo(() => queryParams.roleId ? +queryParams.roleId : undefined, [queryParams]);

    const [profileHistory, setProfileHistory] = useState<ServerResponse<ProfileChangeRecord[]> | null>(null);

    useEffect(() => {
        const loadProfileHistory = async (id: number) => {
            const response = await apiDispatch(getProfileChangeHistory({profileId: id}));
            if (response.payload.success) {
                setProfileHistory({data: response.payload.data.eventList});
            } else {
                setProfileHistory({error: response.payload.data});
            }
        };

        if (profileId !== undefined) {
            loadProfileHistory(profileId);
        }
    }, [profileId, apiDispatch]);

    return (
        <Skeleton shown={!queryParams.roleId || !profileHistory} view={<Loading fast={true}/>}>
            <ServerResponseHandler serverError={profileHistory?.error || null} sectionName="Role History">
                <Routes>
                    <Route
                        path="/:recordId"
                        element={(
                            <ProfileHistoryRecord
                                profileId={profileId || -1}
                                profileHistory={profileHistory?.data || []}
                            />
                        )}
                    />
                    {profileHistory?.data?.length ? (
                        <Route
                            path="*"
                            element={(
                                <Navigate
                                    to={`/roles/${profileId}/history/${profileHistory?.data[0].eventId}/`}
                                    replace={true}
                                />
                            )}
                        />
                    ) : null}
                </Routes>
            </ServerResponseHandler>
        </Skeleton>
    );
};
